import React from "react";

import Logo from "../assets/simbol-Pillar.webp";

export function NavBar({ onOpenModal }) {
  return (
    <div className="navContainer">
      <div className="navUpperSection">
        <div className="navEmailAddressContainer">
          <a href="mailto:info@pillarhydraulics.com?subject=Contact">
            <span>
              {/* <FaRegEnvelope /> */}
              info@pillarhydraulics.com
            </span>
          </a>
        </div>
        <div className="navConsultationBtnContainer">
          <button className="textBtn" onClick={onOpenModal}>
            Contact Us
          </button>
        </div>
      </div>

      <div className="navLowerSection">
        <div className="navLogoContainer">
          <img src={Logo} alt="Pillar Hydraulics Logo" className="navLogo" />
        </div>
        <div className="navPhoneContainer smallText">
          <a href="tel:4036067586">
            <span className="smallText TextHighlight">call us now</span>
          </a>
          <a href="tel:4036067586">
            <span className="smallText yellowTextHighlight">
              +1 403 606 7586
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
